import React, { FC } from "react";
import cn from "classnames";
import { formatNumber2d } from "@utils/format/number";
import FlexLine from "../../../../../../components/elements/flexLine/FlexLine";
import { WorkProgress } from "@baseTypes/service/dashboard/IWorksDashboardService";
import stBase from '../WorkItem.module.scss';
import st from './WorkItemArea.module.scss';

type WorkItemAreaProps = {
    today: WorkProgress
    season: WorkProgress
}

const WorkItemArea: FC<WorkItemAreaProps> = ({ season, today }) => {
    return (
        <FlexLine className={cn(stBase.numbers__line, st.numbers__line)}>
            <div className={st.line}>
                <span className={st.numbers__line_current}>{formatNumber2d(today.cultivatedArea)}</span>
                <span className={st.numbers__line_total}>/{formatNumber2d(today.totalArea)} Га</span>
            </div>
            <div className={st.line}>
                <span className={st.numbers__line_current}>{formatNumber2d(season.cultivatedArea)}</span>
                <span className={st.numbers__line_total}>/{formatNumber2d(season.totalArea)} Га</span>
            </div>
        </FlexLine>
    )
}

export default WorkItemArea;